import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './redux/config';

const store = configureStore({
  reducer: rootReducer,
});

export default store;
